import Vue from 'vue'
import Router from 'vue-router'
import { constantRoutes } from './routes'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  linkExactActiveClass: 'is-active',
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js